import React, { FC } from 'react';
import * as AuthService from './service';
import { pipe } from 'fp-ts/function';
import AuthLayout from '@shared/components/layout/auth/AuthLayout';
import Seo from '@shared/components/seo/Seo';
import { useTranslations } from '@shared/modules/translation/hooks';
import { useSendTask } from '@core/http/hooks';
import { ForgotPasswordParams } from '@modules/auth/model';
import ForgotPasswordForm from '@modules/auth/components/form/ForgotPasswordForm';

const ForgotPassword: FC = () => {
  const translations = useTranslations();

  const [loading, forgotPassword, error, success] = useSendTask(AuthService.forgotPassword);

  const handleSubmit = (params: ForgotPasswordParams) => {
    pipe(() => forgotPassword(params))();
  };

  return (
    <AuthLayout>
      <Seo title={translations.forgotPassword.title} />

      <ForgotPasswordForm loading={loading} error={error} onSubmit={handleSubmit} success={success} />
    </AuthLayout>
  );
};

export default ForgotPassword;
